import { RequestedClassAmount } from './requested-class-amount';

export interface RequestedClassDesignation {
  Name: string;
  RequestedClassAndAmounts: RequestedClassAmount[];
}
